import Helper from '../../../models/Helper';

const URI = '/learning-activity/codevolve';

class CodevolveHelper extends Helper {
  constructor(api) {
    super(api, URI);
  }

  /**
   * @desc Get the codevolve access token for a given content session
   * const request = myClient.helpers.learningActivity
   *                  .codevolve.getToken(contentId);
   * const response = await request.execute();
   */
  getToken(contentId: String) {
    const request = this.api.createGetRequest(this.uri);
    request.url += `/token?contentId=${contentId}`;

    return request.execute();
  }
}

export default CodevolveHelper;
